import {
    get,
    isEqual
} from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import {
    CREATE_ACCOUNT_LOAD,
    CREATE_ACCOUNT_FAILURE,
    CREATE_ACCOUNT_SUCCESS
} from './signupActions';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case CREATE_ACCOUNT_LOAD:
            newState = {
                ...state,
                isLoading: true,
                createAccountError: null,
                wasAccountCreatedSuccessfully: false
            };

            return isEqual(state, newState) ? state : newState;

        case CREATE_ACCOUNT_FAILURE:
            newState = {
                ...state,
                isLoading: false,
                createAccountError: action.error,
                wasAccountCreatedSuccessfully: false
            };

            return isEqual(state, newState) ? state : newState;

        case CREATE_ACCOUNT_SUCCESS:
            newState = {
                ...state,
                isLoading: false,
                wasAccountCreatedSuccessfully: true
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getSignupEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'signup')
);

export const getIsLoading = createSelector(
    getSignupEntity,
    (entity) => get(entity, 'isLoading')
);

export const getCreateAccountError = createSelector(
    getSignupEntity,
    (entity) => get(entity, 'createAccountError')
);

export const getWasAccountCreatedSuccessfully = createSelector(
    getSignupEntity,
    (entity) => get(entity, 'wasAccountCreatedSuccessfully')
);

export const getCreateAccountErrorMessage = createSelector(
    getCreateAccountError,
    (error) => get(error, 'message')
);
